import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { useCallback } from "react";
import { OrganisationService } from "../services/organisation.service";

import { ICreateBrandUser } from "@shared/lib/types";
import {
  BRAND_ME_SEARCH_QUERY_KEY,
  ORGANISATION_LIST_QUERY_KEY,
} from "../constants";

const QUERY_OPTIONS = {
  queryKey: ORGANISATION_LIST_QUERY_KEY,
  skipInvalidation: false,
};

export function useCreateOrganisationUser() {
  const assignUserBrand = useCallback(
    ({
      brandOrganisationId,
      brandUser,
    }: {
      brandOrganisationId: string;
      brandUser: ICreateBrandUser;
    }) =>
      OrganisationService.createOrganisationUser(
        brandOrganisationId,
        brandUser
      ).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    []
  );

  const {
    mutate: createOrganisationUser,
    isLoading: isCreatingOrganisationUser,
    isSuccess: isCreatedOrganisationUser,
  } = useMutation({
    mutationFn: assignUserBrand,
    options: QUERY_OPTIONS,
    onSuccess: (c, _, { brandOrganisationId }) => {
      c.invalidateQueries({
        queryKey: [...ORGANISATION_LIST_QUERY_KEY, brandOrganisationId],
      });
      c.invalidateQueries({
        queryKey: BRAND_ME_SEARCH_QUERY_KEY(brandOrganisationId),
      });
    },
  });

  return {
    createOrganisationUser,
    isCreatingOrganisationUser,
    isCreatedOrganisationUser,
  };
}
